import EventList from "../components/EventList";

const ListEventPage = () => {
  return (
    <EventList />
  );
};

export default ListEventPage;
